<template>
  <HeadlineBlock
    :headline="headline"
    :cols="mappedCols"
    :cols-centered="item.fields.headingColumnPosition === 'centered'"
    :content-centered="item.fields.headingPosition === 'centered'"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'headlineText'
      })
    "
  />
</template>

<script setup lang="ts">
import { HeadlineBlock } from '@hypercodestudio/basler-components';
import { mapColsWidth } from '~/utils/mapColsWidth';
import type { IHeadline } from '~~/lib/ContentfulService';
import { mapHeadline } from '~/utils/mapHeadline';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: IHeadline;
}

const props = defineProps<Props>();
// Generate ID for h2 element: use fields.id if available, otherwise section-${sys.id}
const headlineId = computed(
  () => props.item?.fields.id?.trim() || `section-${props.item.sys.id}`
);
const headline = computed(() => mapHeadline(props.item, headlineId.value));
const mappedCols = computed(() => mapColsWidth(props.item.fields.headingWidth));
</script>
